export const INPUT_LARGE_DEFAULT_Y_PADDING = 14
export const INPUT_LARGE_DEFAULT_X_PADDING = 14

export const INPUT_REGULAR_DEFAULT_Y_PADDING = 9
export const INPUT_REGULAR_DEFAULT_X_PADDING = 12
